<script>
import { Doughnut } from "vue-chartjs";
import * as soluhaApi from "@/soluhaApi";

export default {
  extends: Doughnut,
  props: ["cabang", "bulan"],
  data() {
    return {
      engagementRate: {},
      chartData: {
        labels: ["Diproses", "Diterima", "Ditolak"],
        datasets: [
          {
            label: "My First Dataset",
            data: null,
            backgroundColor: ["#FFCD4D", "#3BE3C0", "#FF7666"],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        legend: {
          display: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    setGrafikEngagementRate(cabang, bulan) {
      soluhaApi
        .getGrafikEngagementRate(cabang, bulan)
        .then((res) => {
          this.engagementRate = res[0];
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  mounted() {
    // render chart
    this.setGrafikEngagementRate(this.cabang, this.bulan);
  },
  watch: {
    cabang: function (newVal, oldVal) {
      this.setGrafikEngagementRate(newVal, this.bulan);
    },
    bulan: function (newVal, oldVal) {
      this.setGrafikEngagementRate(this.cabang, newVal);
    },

    engagementRate: function (newVal, oldVal) {
      this.chartData.datasets[0].data = [
        newVal.pending,
        newVal.accepted,
        newVal.rejected,
      ];
      this.renderChart(this.chartData, this.options);
    },
  },
};
</script>
